<template>
    <Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
        <!-- Start Slider area -->
        <div class="slider-area slider-style-2 variation-2 height-450 bg_image"
             :style="{'background-image': `url(${require(`@/assets/images/banner-index.png`)})`}">
            <div class="container" data-aos="fade-up" data-aos-delay="100">
							<h2 class="w-600 title text-left color-white banner-text mb--0">擁抱技術，驅動產業躍遷</h2>
            </div>
        </div>

        <!-- Start Elements Area -->
        <div class="rwt-advance-tab-area rn-section-gap">
            <div class="container" data-aos="fade-up" data-aos-delay="100">
							<h2 class="w-600 title text-center">關於我們</h2>
							<div class="product">
								<div class="txt" >
									我們始終堅持以「擁抱技術，驅動產業躍遷」為核心理念，依托全球領先技術棧（雲原生、數字原生、AI原生）與自主創新能力，構建「數雲融合」戰略基座，打通數字化轉型全周期鏈路。通過信創產業適配與四大技術引擎協同，推動企業從信息化向智能化、資產化、生態化轉型，重塑數字經濟新範式。
								</div>
							</div>
            </div>
        </div>
        <!-- End Elements Area -->

			<Separator/>

			<div class="rwt-advance-tab-area rn-section-gap">
				<div class="container">
					<h2 class="w-600 title text-center">AI產品</h2>
					<div style="margin-top: 72px">
						<div class="d-flex flex-column flex-lg-row flex-wrap gap-3">
							<div class="swiper-slide index-slide" v-for="(img,index) in bannerList" :key="index">
								<img :src="img.imgUrl" />
								<div class="con-box con-box2">
									<div class="title">{{img.title}}</div>
									<div class="text">{{img.text}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<Separator/>

			<div class="rwt-advance-tab-area rn-section-gap">
				<div class="container">
					<h2 class="w-600 title text-center">數據產品</h2>
					<div style="margin-top: 72px">
						<div class="d-flex flex-column flex-lg-row flex-wrap gap-3">
							<div class="swiper-slide index-slide" v-for="(img,index) in banner2List" :key="index">
								<img :src="img.imgUrl" />
								<div class="con-box">
									<div class="title">{{img.title}}</div>
									<div class="text">{{img.text}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<Separator/>

			<div class="rwt-advance-tab-area rn-section-gap">
				<div class="container">
					<h2 class="w-600 title text-center">行業解決方案</h2>
					<div class="home-programme-list">
						<ul class="clearfix">
							<li v-for="(card,index) in cardList" :key="index">
								<div class="block-box js-m">
									<div class="pic">
										<img :src="card.imgUrl" />
									</div>
									<div class="cont-inner">
										<div class="cont-box">
											<div class="title">{{card.title}}</div>
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>

    </Layout>
</template>

<script>
    import Layout from '../../components/common/Layout'
    import Separator from '../../components/elements/separator/Separator'
		import Swiper from 'swiper'

		import "swiper/css/swiper.css";

    export default {
        name: 'Index',
        components: {Separator, Layout},
        data() {
            return {
							bannerList: [
								{
									imgUrl: require(`@/assets/images/index-s1.png`),
									title: '企業級Agent中台',
									text: '構建覆蓋生成式AI全生命週期的工程化平台，深度融合算力資源、算法模型、領域知識及業務場景四大核心模塊，通過標準化智能流水線助力企業快速實現AI價值轉化，加速數字化升級進程。'
								},
								{
									imgUrl: require(`@/assets/images/index-s2.png`),
									title: 'DeepSeek大模型',
									text: '提供企業級DeepSeek大模型解決方案，依托「算力-模型-知識-應用」四維融合架構，實現從基礎大模型到行業智能體的全鏈路轉化，助力企業構建安全、專屬、高效的生成式AI生產力引擎。'
								},
								{
									imgUrl: require(`@/assets/images/index-s3.png`),
									title: 'PC本地部署大模型',
									text: '我們提供企業級PC端大模型本地化部署產品，支持全鏈路數據安全體系，提供百億級模型輕量化服務引擎，在保證企業數據安全的同時，賦能企業業務，實現降本增效。'
								},
								{
									imgUrl: require(`@/assets/images/index-s4.png`),
									title: '企業級一站式GenAI平台',
									text: '提供企業級GenAI全棧私有化平台產品，實現企業私域數據「輸入-處理-輸出」全生命周期管理，支持RAG增強與知識圖譜構建，確保領域知識精準注入，實現端到端數據閉環體系。'
								}
							],
							banner2List: [
								{
									imgUrl: require(`@/assets/images/index-d1.png`),
									title: '數據安全管控平台',
									text: '構建覆蓋數據全生命週期的安全防護體系，深度融合開發測試、運維管控、業務運營等核心場景，通過模塊化集成實現全域聯防。'
								},
								{
									imgUrl: require(`@/assets/images/index-d2.png`),
									title: '數據治理諮詢與實施服務',
									text: '幫助企業構建標準化、安全化、價值化的數據管理體系，解決數據孤島、質量低下、合規風險等問題，確保業務決策的可靠性與高效率。'
								},
								{
									imgUrl: require(`@/assets/images/index-d3.png`),
									title: '數據治理諮詢與實施服務',
									text: '企業數字化應用開發服務旨在通過定制化軟件系統與智能化工具，幫助企業實現業務流程重構、數據資產增值與運營效率提升。'
								}
							],
							cardList: [
								{
									imgUrl: require(`@/assets/images/index-sol1.png`),
									title: '汽車業服務方案',
								},
								{
									imgUrl: require(`@/assets/images/index-sol2.png`),
									title: '金融業綜合服務方案',
								},
								{
									imgUrl: require(`@/assets/images/index-sol3.png`),
									title: '零售業服務方案',
								}
							]
            }
        },
			mounted() {
			}
    }
</script>
<style lang="scss" scoped>
.swiper-slide {
	text-align: center;
	font-size: 18px;
	background: #fff;
	display: flex;
	align-items: center;
	transition: 300ms;
	justify-content: center;
	position: relative;
	border-radius: 8px;
	img {
		border-radius: 8px;
		width: 100%;
	}

	.con-box {
		text-align: left;
		width: 100%;
		position: absolute;
		left: 0;
		bottom: 0;
		padding: 12px 16px;
		border-radius: 0 0 8px 8px;
		color: #fff;
		background: linear-gradient(to right, #D3001D, rgba(211, 0, 29, 0.1));
		min-height: 104px;
		display: flex;
		flex-direction: column;
		&.con-box2 {
			background: linear-gradient(to right, #2350a0, rgba(35,80,160,0.1));
		}
		.title {
			font-size: 20px;
		}

		.text {
			font-size: 14px;
			flex: 1;
		}
	}
}
.home-programme-list {
	margin-top: 60px;
	.clearfix {
		display: block;
		list-style: none outside none;
		padding: 0;
		margin: 0;
	}
	li {
		float: left;
		width: 33.333%;
		.block-box {
			position: relative;
			.pic {
				position: relative;
				overflow: hidden;
				&:before {
					content: '';
					width: 100%;
					height: 100%;
					background-color: rgba(000, 000, 000, 0.5);
					position: absolute;
					top: 0;
					left: 0;
					z-index: 3;
					transition: all 0.5s ease;
					-webkit-transition: all 0.5s ease;
					-moz-transition: all 0.5s ease;
				}
				img {
					transition: all 0.5s ease;
				}
			}
			&:hover .pic {
				&:before {
					display: none;
				}
				img {
					transform: scale(1.1);
				}
			}
			.cont-inner {
				width: 100%;
				height: 100%;
				position: absolute;
				left: 0;
				bottom: 0;
				z-index: 5;
				display: flex;
				align-items: center;
				justify-content: center;
				.cont-box {
					color: #fff;
					text-align: center;
					.title {
						font-size: 24px;
						font-weight: bold;
					}
				}
			}
		}
	}
}
@media only screen and (max-width: 768px) {
	.home-programme-list {
		margin-top: 0;
		li {
			width: 100%;
		}
	}
}
.js-m {
	transform: translate(0, 30px);
	transition: all 0.8s cubic-bezier(0.79, -0.27, 0.21, 0.82);
}
.product {
	margin-top: 72px;
	display: flex;
	gap: 20px;
	.pic {
		width: 50%;
		img {
			width: 100%;
		}
	}
	.txt {
		flex: 1;
		font-size: 22px;
		text-align: justify;
	}

}
.index-slide {
	flex: 0 0 calc(50% - 1rem);
}
@media only screen and (max-width: 768px) {
	.index-slide {
		width: 100%;
		flex: 1;
		overflow: hidden;
	}
}
.banner-text {
	text-shadow:
		0 0 2px black,
		0 0 2px black,
		0 0 2px black,
		0 0 2px black;
}
</style>
